import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import { router } from "@/router";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
/* The VARIABLE serif, replacing two static cuts, 2026-09-17. This is the last
 * of the design rows and it is the reason every serif heading in the build has
 * been measuring wider than the approved screen: a 40px/600 heading came out at
 * 490px against the mock's 442px.
 *
 * Every mock asks for the font this way (repair-report.html:202-204, and the
 * same three lines in each of the others):
 *   family=Source+Serif+4:opsz,wght@8..60,400;8..60,600;8..60,700
 * Two axes, `opsz` and `wght`, with the optical size running 8 to 60. The build
 * was loading `@fontsource/source-serif-4/latin-400.css` and `latin-600.css`,
 * which are static instances cut at the text optical size, so a 40px heading was
 * being drawn in letterforms designed for body copy: looser, wider, and exactly
 * the divergence the photographs kept showing. `font-optical-sizing` defaults to
 * `auto`, so with the axis present the heading now takes its display-size
 * letterforms from the axis without any further declaration.
 *
 * `standard.css` is the two-axis file. The package ships seven stylesheets and
 * the naming does not say which carries what, so it was established by hash:
 * `files/source-serif-4-latin-standard-normal.woff2` and
 * `files/source-serif-4-latin-opsz-normal.woff2` are byte-identical
 * (sha256 f2ea9c12d2fe9bd3a9589b02ad2c0909da88f30938c91adc838c4f4098f9f9e0),
 * while `-wght-normal.woff2` is a different, smaller, single-axis font. So
 * "standard" here means opsz+wght, which is what the mock asks for; `index.css`
 * and `wght.css` would have dropped the optical size silently.
 *
 * It is one import where there were two because a variable font is one file
 * covering 200-900, which also closes a gap nobody had noticed: the mock asks
 * for 700 as well as 400 and 600, and the build never loaded a 700 cut, so any
 * heading the design sets in bold was being synthesized by the browser.
 *
 * The family name changes with the file, to "Source Serif 4 Variable", which is
 * what these @font-face rules declare. tokens.css keeps the static name behind
 * it in the stack so a reader with the family installed locally is no worse off.
 * One import, all subsets: the package has no per-subset entry, and the browser
 * fetches only the subsets a page's unicode-range needs, so the cyrillic and
 * greek faces cost nothing to declare. */
import "@fontsource-variable/source-serif-4/standard.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@/assets/tokens.css";
import "@/assets/controls.css";

createApp(App).use(createPinia()).use(router).mount("#app");
